import { DatePipe } from "@angular/common";
import { Component, OnInit, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import moment from "moment";
import { ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { Scr } from "src/app/model/scr.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { IntegracaoService } from "../integracao.service";

@Component({
    templateUrl: 'scr-pesquisa.component.html',
    standalone: false
})
export class ScrPesquisaComponent implements OnInit {

    private atributosPaginacaoComponenteListagem: EntityPagedResult<Scr>;
    private scrs:Scr[];
    private opcoesPaginacao:number[];
    public pesquisaForm:UntypedFormGroup;
    public podeEnviarScr: boolean;
    private valoresPesquisaForm: Scr;
    public pesquisado: boolean = false;
    public esconderPesquisa: boolean;

    constructor(
        private integracaoService:IntegracaoService,
        private formBuilder:UntypedFormBuilder,
        private loadingService:BnLoadingService,
        private permissaoService: PermissaoService,
        private datePipe:DatePipe){
        
        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };
        this.pesquisaForm = this.formBuilder.group({
            ativo: 'S',
            dataReferencia: moment().subtract(1,'month').format('MM/YYYY'),
            dataCriacaoInicial: null,
            dataCriacaoFinal: null,
            foiUtilizadoNaCriticaDeHonra:null
        });
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscar();
    }

    ngOnInit(): void {

       this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
        this.podeEnviarScr = resp && resp[ROLE_GESTOR_ENVIO];
        if(this.podeEnviarScr && this.integracaoService.realizarPesquisa){
            this.pesquisaForm.setValue({
                ativo: null,
                dataReferencia: null,
                dataCriacaoInicial: null,
                dataCriacaoFinal: null,
                foiUtilizadoNaCriticaDeHonra:null
            });
            this.pesquisaForm.valueChanges.subscribe(()=>{
                this.atributosPaginacaoComponenteListagem.page = 1;
            })
            this.buscar();
        }
        this.esconderPesquisa = true;
      });
    }

  

    
    limpar(){
        this.pesquisaForm.setValue({
            dataReferencia: '',
            ativo: null,
            dataCriacaoInicial: null,
            dataCriacaoFinal: null,
            foiUtilizadoNaCriticaDeHonra:null
        });
        this.scrs = [];
        this.pesquisado = false;
        this.atributosPaginacaoComponenteListagem.page = 1;
    }

    mudancaPagina(novaPagina: EntityPagedResult<Scr>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.esconderPesquisa = true;
        this.buscar();
    }
    
    buscar(){

        const params:any = {};
        const dadoFormulario = this.pesquisaForm.getRawValue();
        if(dadoFormulario.ativo){
            params.situacao = dadoFormulario.ativo;
        }
        if(dadoFormulario.dataReferencia){
            const dataObjeto = moment(dadoFormulario.dataReferencia, 'MM/YYYY').toDate();
            params.dataReferencia = this.datePipe.transform(dataObjeto,"yyyy-MM");
        }

        if(dadoFormulario.dataCriacaoInicial){
            params.dataCriacaoInicial = this.datePipe.transform(dadoFormulario.dataCriacaoInicial,"yyyyMMdd");
        }
        if(dadoFormulario.dataCriacaoFinal){
            params.dataCriacaoFinal = this.datePipe.transform(dadoFormulario.dataCriacaoFinal,"yyyyMMdd");
        }
        
        if(dadoFormulario.foiUtilizadoNaCriticaDeHonra){
            params.foiUtilizadoNaCriticaDeHonra= dadoFormulario.foiUtilizadoNaCriticaDeHonra;
        }
        
        if(!this.esconderPesquisa){
            this.atributosPaginacaoComponenteListagem.page = 1;
        }
        
        params.pagina = this.atributosPaginacaoComponenteListagem.page;
        params.limite = this.atributosPaginacaoComponenteListagem.pageSize;


        this.loadingService.bloqueiaTela();
        this.integracaoService.getScrs(params).subscribe(response => {
            this.scrs = response ? response.resultados : undefined;
            this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
            this.loadingService.liberaTela();
            this.pesquisado = true;
            this.esconderPesquisa = false;

        },()=>this.loadingService.liberaTela());
    }
}